<template>
<v-row justify="center">
    <router-link to @click="irTopo"></router-link>
    <v-col cols="12" sm="12" md="12" lg="12" class="d-flex justify-start">
        <h2 class="pr-8">Solicitações</h2>
        <v-btn 
            elevation="0"
            rounded
            large
            color="primary" 
            @click="addRequest"
            :disabled = "VerificaOrigemProcura">
            <v-icon left>mdi-text-box-plus-outline</v-icon>
            Nova Solicitação
        </v-btn>
    </v-col>
    <v-col cols="12" sm="12" md="12" lg="12">
        <v-expansion-panels accordion>
            <v-expansion-panel>
                <v-expansion-panel-header class="blue white--text">
                    <span>Filtros de pesquisa</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <p></p>
                    <v-form
                        ref="form"
                    > 
                        <v-row>
                            <v-col cols="12" sm="6" md="3" lg="3">
                                <v-text-field
                                outlined
                                clearable
                                required
                                v-model="numerosolicitacao"
                                label="Protocolo"
                                maxLength="20"
                                type="number"
                                id="txtNumeroSolicitacao"
                                v-on:keyup.enter="search"
                                />
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="3">
                                <v-select
                                outlined
                                clearable
                                label="Perfil da solicitação"
                                :items="listPerfilSolicitacao"
                                v-model="perfilsolicitacao"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="5" lg="5">
                                <v-select 
                                    outlined
                                    clearable
                                    label="Motivo de procura"
                                    :items="listMotivos"
                                    v-model="motivoprocura"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="8" md="3" lg="3">
                                <v-select 
                                outlined
                                clearable
                                :items="listSituacaoSolicitacao"
                                item-value="cd_situacao_solicitacao_vaga"
                                item-text="dc_situacao_solicitacao_vaga"
                                label="Situação"
                                v-model="status"></v-select>
                            </v-col>
                            <v-col  cols="12" sm="6" md="2" lg="2">
                                <v-text-field
                                outlined
                                clearable
                                v-model="dataNascimento"
                                label="Data de Nascimento"
                                type="date"
                                />                    
                            </v-col>  
                            <v-col cols="12" sm="6" md="4" lg="4">
                                <v-text-field
                                outlined
                                maxLength="70"
                                clearable
                                v-model="nomeCidadao"
                                label="Nome do Cidadão"
                                type="text"
                                />                    
                            </v-col>  
                            <v-col cols="12" sm="6" md="3" lg="3">
                                <v-text-field
                                outlined
                                maxLength="30"
                                clearable
                                v-model="nomeSocial"
                                label="Nome Social"
                                type="text"
                                />                    
                            </v-col> 
                            <v-col cols="12" sm="6" md="3" lg="3">
                                <v-text-field
                                outlined
                                maxLength="70"
                                clearable
                                v-model="nomeMae"
                                label="Nome da Mãe"
                                type="text"
                                />                    
                            </v-col>  
                            <v-col cols="12" sm="6" md="3" lg="3">
                                <v-text-field
                                outlined
                                clearable
                                v-model="dataSolicitacao"
                                label="Data da Solicitação"
                                type="date"
                                />                    
                            </v-col>   
                            <v-col cols="12" sm="12" md="7" lg="7">
                                <v-text-field
                                outlined
                                maxLength="70"
                                clearable
                                v-model="responsavelSolicitacao"
                                label="Responsável pela Solicitação"
                                type="text"
                                />                    
                            </v-col>  
                            <v-col cols="12" sm="12" md="5" lg="5" align="right" class="align-right">
                                <v-btn
                                elevation="0"
                                rounded
                                color="primary"
                                x-large
                                @click="search">
                                <v-icon left>mdi-magnify </v-icon>
                                Pesquisar
                                </v-btn>
                            </v-col>                                                           
                        </v-row>
                    </v-form>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
                <v-data-table
                    :headers="headers"
                    :items="listRequest"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :footer-props="$config.pagingProps"
                    :items-per-page="$config.maxItensPerPage"
                    :loading="loading"
                    elevation="0"
                >
                    <template v-if="nodata" v-slot:no-data>
                        <v-chip label>
                            <span>{{ error }}</span>
                        </v-chip>
                    </template>
                    <template v-slot:item.dataHoraSolicitacao="{ item }">
                        <span>{{ item.dataHoraSolicitacao | formatDateTime_BR() }}</span>
                    </template>                
                    <template v-slot:item.actions="{ item }">
                        <div class="d-flex justify-end">
                            <div>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            v-on="on"
                                            icon
                                            small
                                            @click="$router.push({ name: 'RequestDetail', params: { id: item.idSolicitacao } })"
                                        >
                                            <v-icon>mdi-eye</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Visualizar</span>
                                </v-tooltip>
                            </div>
                            <div>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            v-on="on"
                                            v-if="item.status === 1"
                                            icon
                                            small
                                            @click="deleteSolicitacao(item.idSolicitacao)"
                                        >
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Excluir</span>
                                </v-tooltip>
                            </div>
                            <div>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            v-on="on"
                                            icon
                                            small
                                            @click="$router.push({ name: 'RequestDetailPrint', params: { id: item.idSolicitacao } })"
                                        >
                                            <v-icon>mdi-printer</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Imprimir</span>
                                </v-tooltip>
                            </div>   
                        </div>                    
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-col>
        <snackbar
            :text="snackbarMessage"
            :color="snackbarColor"
        />
        <v-dialog
            v-model="showDialogMessage"
            width="500"
        >
            <v-card>
                <v-card-title class="light-blue darken-4 white--text">
                Atenção!
                </v-card-title>

                <v-card-text>
                    <br />
                    <div v-html="dialogTextMessage" />
                </v-card-text>

                

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    large
                    outlined
                    rounded
                    elevation="0"
                    @click="showDialogMessage = false"
                >
                    CONFIRMAR
                </v-btn>
                </v-card-actions>
            </v-card>    
        </v-dialog>        
</v-row>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import snackbarMixin from "@/mixins/snackbar.mixin";
import requestService from '../../services/request.service';

  export default {
  mixins: [snackbarMixin],
  data(){
    return{
        headers: [
            { text: "Protocolo", value: "idSolicitacao" },
            { text: "Data/Hora", value: "dataHoraSolicitacao" },
            { text: "Responsável solicitação", value: "nomeResponsavelSolicitacao" },
            { text: "Tipo de Solicitacao", value: "descricaoTipoSolicitacao" },
            { text: "Situação", value: "descricaoStatusSolicitacao" },
            { text: "Ações", value: "actions", sortable: false },
        ],
        sortBy: 'idSolicitacao',
        sortDesc: true,
        listMotivos:[],
        listSituacaoSolicitacao:[],
        loading: false,
        nodata: true,
        error: "",
        numerosolicitacao:'',
        motivoprocura:'',
        status:'',
        perfilsolicitacao:'',
        dataSolicitacao: '',
        responsavelSolicitacao: '',
        nomeMae: '',
        nomeSocial: '',
        dataNascimento: '',
        nomeCidadao: '',
        listPerfilSolicitacao:[{text:'Individual', value:'I'},{text:'Casal', value:'C'},{text:'Grupo Familiar', value:'G'}],
        listRequestService: [],
        showDialogMessage: false,
        dialogTextMessage: '',
    }
  },
  computed:{
    ...mapGetters("request", ["listRequest"]),
    ...mapGetters("common", ["getSourceSearch","getRequestingAgency", "getPreviousPage"]),
    ...mapGetters("login", ["delegatedUser"]),

    VerificaOrigemProcura(){
        console.log('this.getSourceSearch',this.getSourceSearch);
        console.log('this.isTrueValue(this.delegatedUser)', this.isTrueValue(this.delegatedUser));
        console.log('this.Validação',!this.isTrueValue(this.delegatedUser) && this.getSourceSearch == null || this.getSourceSearch == undefined || this.getSourceSearch.length == 0);
        
        if(this.isTrueValue(this.delegatedUser))
        {
            return false;
        }
       else if (this.getSourceSearch == null || this.getSourceSearch == undefined || this.getSourceSearch.length == 0)
            {

                console.log('condicao 2 xxx false');
                //this.tipoSolicitacao = 'A';
                return true;
                
            }
        else
            {
                console.log('condicao 3 xxx true');
                return false;
                
            }

            //return ();
        },

  },
  watch: {
    list: function () {
        if (this.listRequest <= 0) {
            this.nodata = true;
        } else {
            this.nodata = false;
        }
    },
    options: {
        handler() {
            this.search();
        },
        deep: true,
    },

},
    mounted() {
        this.loadMotivoProcura();
        this.loadSituacaoSolicitacao();
        this.updateIsLoginPage(false);
        this.setSourceSearch();
        if(this.$store.getters['common/getPreviousPage'] != 'listRequest'){
            this.$store.state.request.list = [];
        }
        this.updatePreviousPage('listRequest');
    },
    methods:{
        ...mapMutations('common', ['updateSourceSearch','updateRequestingAgency','updateEnabledReordering','updateSourceSearchSelected','updatePreviousPage']),        
        ...mapMutations('login', ['updateIsLoginPage','clearListRequest']),
        addRequest(){
            this.$router.push('Request');
        },
        irTopo(){
            window.scrollTo(0,0);
        },
        async loadMotivoProcura(){
            await this.$store.dispatch("lists/listMotivoProcura");
            try {
                let motivos = this.$store.state.lists.listMotivoProcura;
                this.listMotivos = [];
                for (let index = 0; index < motivos.length; index++) {
                    this.listMotivos.push({
                        text: motivos[index].Descricao,
                        value: motivos[index].Id,
                    });
                }
            } catch (error) {
                this.showSnackbar(error, 'error');
            }
        },
        async loadSituacaoSolicitacao(){
            await this.$store.dispatch("lists/listSituacaoSolicitacao");
            try {
                let situacoes = this.$store.state.lists.listSituacaoSolicitacao;
                this.listSituacaoSolicitacao = situacoes;
            } catch (error) {
                this.showSnackbar(error, 'error');
            }
        },
        async search(){
            if(!this.isTrueValue(this.delegatedUser) && (this.getSourceSearch == null || this.getSourceSearch == undefined || this.getSourceSearch.length == 0)){
                this.dialogTextMessage = "Informe o órgão solicitante para qual está efetuando a pesquisa";
                this.showDialogMessage = true;
                this.loading = false;
                return false;
            }

            try {
                this.loading = true;
                let data = this.getFilters();
                await this.$store.dispatch("request/listRequest", data);
                this.nodata = false;

            } catch (error) {
                this.error = error;
                this.nodata = true;
            }finally{
                this.loading = false;
            }
        },
        getFilters(){
            var objLogin = this.$store.state.login;
            let filters= {
                codigoUsuarioInclusao: objLogin.userLogin,
                idSolicitacao: this.numerosolicitacao,
                tipoPerfilSolicitacao: this.perfilsolicitacao,
                codigoMotivoProcuraConsulta: this.motivoprocura,
                statusSolicitacaoConsulta: this.status, 
                dataHoraSolicitacao: this.dataSolicitacao,
                nomeResponsavelSolicitacao: this.responsavelSolicitacao,
                codigoOrigemProcura: (this.isTrueValue(this.delegatedUser)) ? '' : this.getSourceSearch,
                codigoOrgaoSolicitante: (this.isTrueValue(this.delegatedUser)) ? '' : this.getRequestingAgency,
                cidadaos: [
                    {
                        nomeMae: this.nomeMae,
                        nomeSocial: this.nomeSocial,
                        dataNascimento: this.dataNascimento,
                        nome: this.nomeCidadao,
                    }
                ]
            };
            return filters;
        },
        deleteSolicitacao(idSolicitacao){
            let msg = 'Deseja realmente excluir a solicitação ' + idSolicitacao + '?';
            console.log(msg);
            this.$root.$confirm.open('Delete', msg)
            .then((res) => {
                if(res == true) {
                    requestService.deleteSolicitacaoById(idSolicitacao)
                    .then(result =>{
                        if(result.status == "200"){
                            if(result.data.status == "OK"){
                                this.showSnackbar("Solicitação excluida", 'success');
                                this.search();
                            } else {
                                this.showDialogMessage = true;
                                this.dialogTextMessage = '<ul><li>' + result.data.errors.join('</li><li>') + '</li></ul>';
                            }
                        }
                    }
                    ).catch(error =>{
                        this.showSnackbar("Não foi possível excluir a solicitação.", 'error');
                        console.log(error);
                    });
                }
            })
        },
        customSort(items, index, isDesc) {
            if(index == "idSolicitacao")
                if(!(isDesc == "true"))
                    this.listRequestService.sort(function (obj1, obj2) { return obj1.idSolicitacao < obj2.idSolicitacao ? -1 : (obj1.idSolicitacao > obj2.idSolicitacao ? 1 : 0); });
                else
                    this.listRequestService.sort(function (obj1, obj2) { return obj1.idSolicitacao > obj2.idSolicitacao ? -1 : (obj1.idSolicitacao < obj2.idSolicitacao ? 1 : 0); });


            return this.listRequestService;
        },
        setSourceSearch(){
            this.$root.$emit('header_setSourceSearch');
        }, 
        isTrueValue(value){
            let isTrue = ((value != undefined) && (value.toLowerCase() == "true" || value == "1" || value == true || value === 1));
            return isTrue;
        },
    }
}
</script>
<style scoped>
/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted rgb(228, 220, 220); /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: rgb(228, 220, 220);
  color: black;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
 
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
  top: -5px;
  right: 105%;

}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}
.theme--light.v-btn--active:before, .theme--light.v-btn--active:hover:before {
        opacity: 0 !important;
}
</style>